
export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  remaining_ai_token?: number;
}

export enum AppStep {
  IDEATION = 'ideation',
  VISUALS = 'visuals'
}

export type Language = 'zh' | 'en';

export interface CreationRecord {
  id: string;
  projectNo?: string; // 后端返回的项目编号
  projectName?: string; // 项目名称
  userId?: string;
  timestamp: number;
  initialIdea: string;
  // 获取路由参数 用户来源
  rdtm_from?: string;
  // PRD 结构化字段
  coreDescription?: string;         // 产品核心描述
  scenariosPainPoints?: string;     // 使用场景与核心痛点
  userPersona?: string;             // 目标用户画像
  appearanceMaterials?: string;     // 外观偏好与材质质感
  featureDetails?: any[];           // 核心功能细节
  interactionOperation?: string;    // 用户交互与操作
  keyComponents?: any[];            // 关键零部件定义
  controlLogic?: string;            // 控制逻辑与软件
  performanceGoals?: string;        // 性能目标与效率指标
  costBom?: any[];                  // 成本控制与BOM预算
  mfgQuality?: string;              // 制造品质与耐用性
  sizePkg?: string;                 // 尺寸限制与包装需求
  supplyChain?: string;             // 供应链与材料约束
  compliance?: string;              // 行业合规标准
  deliveryMilestones?: string;      // 交付时间节点
  
  prd?: string; // 保留原始全文供参考
  mainImage: string;
  images?: string[]; 
  ver_images?: string[][];
  nowVersion?: number;
  messages?: any[]; 
  isSubmitted?: boolean;
  
  // 统计
  totalTokens?: number;
  totalUsd?: number;
  status?: 'prd_designing' | 'visual_designing' | 'eng_evaluating';
}

export interface PointTransaction {
  id: string;
  userId?: string; // Add userId
  description: { zh: string; en: string };
  projectName?: string; // 新增项目名称字段
  amount: number;
  timestamp: number;
}

export type ComponentCategory = 
  | 'CNC' | '注塑' | '钣金' | '压铸' 
  | 'PCB' | '线' 
  | '太阳能板' | '电池' | '马达';

export interface PartInfo {
  name: string;
  type: 'structural' | 'electronic' | 'critical';
  category?: string;
  description: string;
  imageUrl?: string;
  material?: string;
  process?: string;
  quantity?: number;
  position?: string; 
  specs?: string;    
}

export interface ExplodedScheme {
  id: string;
  title: string;
  logic: string;
  imageUrl: string;
  parts: PartInfo[];
  timestamp: number;
}
